<template>
    <base-dialog :value="dialog" :width="420" :title="$t('common.set_prescription')"
        @input="val => { if (!val) hide() }" @close="hide">
        <div class="sp-fields">
            <kimsa-text-field :label="$t('exercises.tags')" dense force-value no-elevation :value="tags"
                @change="tags = $event" />
            <kimsa-combobox :label="$t('common.name')" dense :items="prescriptions" @change="prescription = $event"
                ref="prescriptions" can-write no-create-exercise :loading="loadingSearch" @search="search = $event" />
        </div>

        <template v-slot:footer>
            <dialog-actions hide-cancel :confirm-label="$t('common.apply')" :disabled="disabled"
                @confirm="setPrescription" />
        </template>
    </base-dialog>
</template>

<script>


import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import { PrescriptionIndex } from "@/utils/Algolia";
import { debounce } from '@/utils/Common'
import KimsaTextField from '../../common/inputs/KimsaTextField.vue';
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";

export default {
    name: 'SetPrescriptionDialog',
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
        category: {
            type: [Object, String],
            default: null,
        },
        coachId: {
            type: String,
            default: null,
        },
    },
    components: {
        KimsaCombobox,
        KimsaTextField,
        BaseDialog,
        DialogActions,
    },
    data() {
        return {
            dialog: false,
            prescriptions: [],
            prescription: null,
            search: '',
            loadingSearch: false,
            tags: '',
        }
    },
    computed: {
        disabled(vm = this) {
            return !vm.prescription
        }
    },
    methods: {
        show() {
            const vm = this
            vm.dialog = true
            vm.loadPrescriptions()
        },
        hide() {
            const vm = this
            vm.dialog = false
            if (vm.$refs.prescriptions) vm.$refs.prescriptions.model = null
        },
        setPrescription() {
            const vm = this
            vm.$emit('set', vm.prescription)
            vm.hide()
        },
        async loadPrescriptions() {
            const vm = this;
            if (!vm.category || !vm.dialog) return
            vm.loadingSearch = true
            let filter = `coachId: ${vm.coachId}`
            if (vm.category?.id) {
                filter += ` AND category:${vm.category.id}`
            } else {
                filter += ` AND categoryName:"${vm.category}"`
            }
            if (vm.tags) filter += ` AND tags:"${vm.tags}"`
            try {
                let response = await PrescriptionIndex.search(vm.search, {
                    filters: filter,
                    hitsPerPage: 50,
                })
                vm.prescriptions = response.hits
            } catch (err) {
                console.log(err)
            } finally {
                vm.loadingSearch = false
            }
        },
        debouncedLoadPrescriptions: debounce(
            function () {
                this.loadPrescriptions()
            }, 1000),
    },
    watch: {


        category() {
            this.loadPrescriptions()
        },
        tags() {
            this.debouncedLoadPrescriptions()
        },
        search() {
            this.debouncedLoadPrescriptions()
        },
    }
}

</script>

<style scoped>
.sp-fields {
    display: flex;
    flex-direction: column;
    gap: 14px;
}
</style>